import React from "react";
import { useNavigate } from "react-router-dom";
import { useGlobalState } from "../../helpers/GlobalStateProvider";

interface WalletInfoProps {
  disconnectWallet: () => void;
  info: any;
}

const WalletInfo: React.FC<WalletInfoProps> = ({
  info,
  disconnectWallet
}) => {
  const walletAddress = info?.walletAddress
  const formattedAddress = walletAddress ? `0x${walletAddress.toUpperCase().slice(2, 9)}` : '';
  let tier = "FREE";
  if (info?.tier > 0) tier = "PRO";

  const goToSignin = () => {
    navigate('/signin')
  }

  const{ isSignedIn } = useGlobalState();

  const navigate = useNavigate();
  return (
    <div
      style={{
        width: 320,
        height: 242,
        paddingTop: 36,
        paddingBottom: 36,
        paddingLeft: 36,
        paddingRight: 24,
        background: "#ffffff",
        boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
        borderRadius: 16,
        border: "1px solid #e4e4e7",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: 36,
      }}
    >
      <div
        style={{
          alignSelf: "stretch",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          gap: 12,
        }}
      >
        <img
          src="/external/rectangle11.png"
          alt="Wallet Icon"
          style={{
            width: 48,
            height: 48,
            borderRadius: 18,
          }}
        />
        <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
          <div
            style={{
              color: "#18181b",
              fontSize: 16,
              fontWeight: "800",
              lineHeight: "24px",
            }}
          >
            {formattedAddress}
          </div>
          <div
            style={{
              color: "#18181b",
              fontSize: 14,
              fontWeight: "700",
              lineHeight: "21px",
            }}
          >
            {tier}
          </div>
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            cursor: "pointer",
          }}
          onClick={isSignedIn() ? disconnectWallet : goToSignin}
        >
          <img
            src="/external/arrow-right-start-on-rectangle.svg"
            alt="Sign Out Icon"
            style={{
              width: 16,
              height: 16,
            }}
          />
          <div
            style={{
              color: "#9333ea",
              fontSize: 14,
              fontWeight: "400",
              lineHeight: "21px",
            }}
          >
            {isSignedIn() ? 'Sign Out' : 'Sign In'}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            cursor: "pointer",
          }}
          onClick={() => window.open("https://coincap.io", "_blank", "noopener,noreferrer")}
        >
          <img
            src="/external/group-18.svg"
            alt="CoinCap.io Icon"
            style={{
              width: 16,
              height: 16,
            }}
          />
          <div
            style={{
              color: "#9333ea",
              fontSize: 14,
              fontWeight: "400",
              lineHeight: "21px",
            }}
          >
            CoinCap.io
          </div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            cursor: "pointer",
          }}
          onClick={() => window.open("https://mee6.xyz/en/i/S3ZfymIhLR", "_blank", "noopener,noreferrer")}
        >
          <img
            src="/external/question-mark-circle.svg"
            alt="Help Icon"
            style={{
              width: 16,
              height: 16,
              filter: "brightness(0)",
            }}
          />
          <div
            style={{
              color: "#9333ea",
              fontSize: 14,
              fontWeight: "400",
              lineHeight: "21px",
            }}
          >
            Help
          </div>
        </div>
      </div>
    </div>
  );
};

export default WalletInfo;
